import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';

interface LoginFormProps {
  onSwitchToRegister: () => void;
}

const LoginForm: React.FC<LoginFormProps> = ({ onSwitchToRegister }) => {
  const { login, isLoading, error, clearError } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await login(email, password);
  };
  
  return (
    <div className="auth-form-container">
      <h2 className="auth-title">Login to <span className="text-gradient">Digital Workplace</span></h2>
      
      {error && (
        <div className="auth-error">
          {error}
          <button className="error-close" onClick={clearError}>×</button>
        </div>
      )}
      
      <form className="auth-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            placeholder="Enter your email"
            className="auth-input"
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="password">Password</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            placeholder="Enter your password"
            className="auth-input"
          />
        </div>
        
        <div className="form-footer">
          <button 
            type="submit" 
            className="auth-button" 
            disabled={isLoading}
          >
            {isLoading ? (
              <span className="loading-spinner"></span>
            ) : 'Login'}
          </button>
        </div>
      </form>
      
      <div className="auth-switch">
        <p>Don't have an account?</p>
        <button 
          className="switch-button" 
          onClick={onSwitchToRegister}
          disabled={isLoading}
        >
          Register
        </button>
      </div>
      
      <div className="auth-demo">
        <h3>Demo Credentials</h3>
        <p><strong>Email:</strong> demo@example.com</p>
        <p><strong>Password:</strong> password</p>
      </div>
    </div>
  );
};

export default LoginForm;
